<template>
<!-- card mode -->
  <v-card class="roma-card full-h roma-elevation-3" 
  style="cursor: pointer;" 
  :to="{ name: 'Lesson Detail', params: { id: lesson.lessonId } }">
    <v-card-text class="full-h">
      <v-container class="pa-0">
        <v-row no-gutters class="mb-1 mt-3">
            <v-col>
              <span class="ml-3 subtitulo-5 py-1 px-2 font-inter" :style="{ color: '#743085', background: '#F1E6FF', 'border-radius': '8px'}">
                {{
                  lesson.section.nameAndCategoryName
                }}
              </span>
            </v-col>
        </v-row>

        <!-- subheader -->
        <v-row no-gutters class="mb-5">
          <v-col>
            <strong class="roma-card__subject px-3 titulo-5 color-neutro-0">
              {{ textCapitalize(parserTitleSubject) }}
            </strong>
          </v-col>
        </v-row>

        <v-row no-gutters="" class="mt-1 ml-3 mb-1">
          <v-col cols="auto">
            <span class="font-inter subtitulo-2 color-neutro-1">
              {{ lesson.code }}
            </span>
          </v-col>
        </v-row>

        <v-row no-gutters="" class="ml-3">
           <v-col cols="auto">      
                <span
                  class="font-inter titulo-3 color-neutro-0"
                >
                  {{ textCapitalize( lesson.title ) }}
                </span>
                
          </v-col>
        </v-row>
        
        <v-row no-gutters="" class="ml-3 mb-3">
           <v-col cols="auto">      
              <span class="font-inter parrafo-2 color-neutro-0">
                {{ cleanHTMLTags(lesson.description)}}
              </span>
          </v-col>
        </v-row>


      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>

export default {
  props: ["lesson"],
  computed: {
    gridLesson() {
      return this.$store.getters.getGridColumnLesson;
    },
    parseDate() {
      const dateFormat = this.lesson.date.split(" ");
      return dateFormat[0];
    },
    getState() {
      const { editState } = this.lesson;
      return editState === "EN_EDICION" ? "Edición" : "";
    },
    parserTitleSubject() {
      const value = this.lesson.subject.name;
      return value.toLowerCase();
    },
    getProgressNumber() {
      return this.lesson.percentageCompletion === null
        ? 0
        : this.lesson.percentageCompletion;
    },
  },
  data() {
    return {
      value: 50,
      color: "primary",
      dropDownOptions: [
        {
          title: this.$vuetify.lang.t("opcion 1"),
          icon: "mdi-checkbox-blank-circle",
          status: false,
          action: () => {
            console.info("hey 1");
          },
        },
        {
          title: this.$vuetify.lang.t("Activar"),
          icon: "mdi-checkbox-blank-circle",
          status: true,
          action: () => {
            console.info("hey 3");
          },
        },
        {
          title: this.$vuetify.lang.t("Inactivar"),
          icon: "mdi-checkbox-blank-circle",
          status: true,
          action: () => {
            console.info("hey 3");
          },
        },
        {
          title: this.$vuetify.lang.t("Cerrar Edición"),
          icon: "mdi-checkbox-blank-circle",
          status: true,
          action: () => {
            console.info("hey 3");
          },
        },
        {
          title: this.$vuetify.lang.t("Eliminar Clase"),
          icon: "mdi-checkbox-blank-circle",
          status: true,
          action: () => {
            console.info("hey 3");
          },
        },
      ],
    };
  },
  methods: {
    download() {
      alert("Descargar recurso");
    },
    textCapitalize(value){
      let aux = value.trim().split(' ');
      aux = aux.filter( element => element != '');
      aux = aux.map( (word, index) => {
        word = word.trim();
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      })
      return aux.join(' ');
    },
    cleanHTMLTags(value){
      return value.replace(/<\/?[^>]+(>|$)/g, "");
    },
    progress(value) {
      console.log("Valor progreso: "+value);
	      if (value <= 25) {
	        this.color = "secondary";
	      } else if (value >= 26 && value <= 49) {
	        this.color = "purple";
	      } else if (value >= 50 && value <= 75) {
	        this.color = "accent";
	      } else if (value >= 76 && value <= 90) {
	        this.color = "blueMedium";
	      } else {
	        this.color = "success";
	      }
	      return this.color;
    },
  },
};
</script>
<style lang="scss">
$fixed-size: 3px;
.roma-card {
  .dropdown-wrapper {
    position: relative;
    .card-dropdown {
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
    }
  }
  .btn-edit {
    .v-btn__content {
      font-size: 14px;
    }
  }
  &__custom-container {
    display: grid;
    align-items: baseline;
    grid-template-rows: max-content max-content 1fr max-content;
  }
  .card-container-footer {
    position: absolute;
    bottom: 20px;
    left: 18px;
    right: 18px;
  }
  .loading-card {
    height: 250px;
  }
  .middle {
    margin-top: 20px;
  }
}
</style>
